import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../core/guards/auth.guard';
import { DetalleComponent } from './pages/detalle/detalle.component';
import { LogoutComponent } from '../login/pages/logout/logout.component';
import { AdministracionDePuntajesComponent } from './pages/administracion-de-puntajes/administracion-de-puntajes.component';
import { CompletoComponent } from './pages/completo/completo.component';


const routes: Routes = [
  { path: 'detalle/evaluacion-completa/:mission', component: CompletoComponent, canActivate: [AuthGuard] },
  { path: 'detalle/:instruction/:mission', component: DetalleComponent, canActivate: [AuthGuard] },
  { path: 'administrar-puntajes', component: AdministracionDePuntajesComponent, canActivate: [AuthGuard] },
  { path: 'logout', component: LogoutComponent /*canActivate: [AuthGuard] */ },
  //{ path: 'asignaciones', component: AsigancionesComponent, canActivate: [AuthGuard, RolGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministracionRoutingModule { }
